import { useState } from 'react'
import { ShopCheckoutSideBarResponse } from '../models'
import { useShopFetchWithResult } from './use-shop-fetch'
import { deleteQntmPdfContract, readQntmContract, uploadQntmPdfContract } from '../api/shop-qntm-pdf-upload.api'

/*
 * This Custom Hook have all Quantum Pdf Endpoints.
 */

interface UseShopQntmPdfHook {
  addQntmContract: (pdf: Blob) => Promise<ShopCheckoutSideBarResponse | null>
  removeQntmContract: () => Promise<ShopCheckoutSideBarResponse | null>
  openQntmContract: () => Promise<string | null>
  isLoading: boolean
}

const useShopQntmPdf = (): UseShopQntmPdfHook => {
  const shopFetch = useShopFetchWithResult()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const addQntmContract = async (pdf: Blob): Promise<ShopCheckoutSideBarResponse | null> => {
    try {
      setIsLoading(true)
      const response = await uploadQntmPdfContract(pdf, shopFetch)
      return response.value
    } catch (error) {
      console.error(error)
      return null
    } finally {
      setIsLoading(false)
    }
  }

  const removeQntmContract = async (): Promise<ShopCheckoutSideBarResponse | null> => {
    try {
      setIsLoading(true)
      const response = await deleteQntmPdfContract(shopFetch)
      return response.value
    } catch (error) {
      console.error(error)
      return null
    } finally {
      setIsLoading(false)
    }
  }

  const openQntmContract = async (): Promise<string | null> => {
    try {
      setIsLoading(true)
      const response = await readQntmContract(shopFetch)
      return response.value
    } catch (error) {
      console.error(error)
      return null
    } finally {
      setIsLoading(false)
    }
  }

  return {
    addQntmContract,
    removeQntmContract,
    openQntmContract,
    isLoading,
  }
}

export default useShopQntmPdf
